<p-dialog
  (onHide)="dialog?.onHide?.()"
  [style]="{ width: dialog?.width || '600px' }"
  [(visible)]="visible"
  [closeOnEscape]="!!dialog?.closeOnEscape"
  [dismissableMask]="!!dialog?.dismissableMask"
  [modal]="true"
  draggable="false"
  resizable="false"
  [contentStyleClass]="dialog?.contentClass"
  >
  <ng-template #header>
    <div class="flex flex-col gap-2">
      <span class="font-bold text-xl block">{{ dialog?.title || '' | translate }}</span>
      <span class="opacity-70">{{ dialog?.description || '' | translate }}</span>
    </div>
  </ng-template>
  <div class="flex flex-col h-full">
    <div class="flex-1 overflow-auto">
      <ng-container [ngComponentOutlet]="dialog?.component?.outlet" [ngComponentOutletInputs]="dialog?.component?.props"></ng-container>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button
        *ngFor="let action of dialog?.actions"
        [label]="action.label | translate"
        [severity]="action.variant"
        [disabled]="action.disabled | async"
        (click)="handleActionClick(action)" />
    </div>
  </ng-template>
</p-dialog>
